import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { fetchOrganization, updateOrganization } from '@/enitites/organization/api/endpoints'
import { Organization } from '@/modules/Organizations/types'
import CreateOrganizationAdmins from '@/modules/Organizations/components/create-organization/CreateOrganizationAdmins.vue'
import CreateOrganizationInfo from '@/modules/Organizations/components/create-organization/CreateOrganizationInfo.vue'
import CreateOrganizationPromoters from '@/modules/Organizations/components/create-organization/CreateOrganizationPromoters.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateOrganization',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const stages = [CreateOrganizationInfo, CreateOrganizationAdmins, CreateOrganizationPromoters]
const currentStage = ref(0)
const org = ref<Organization>()

const updateOrg = async () => {
  if (!org.value) return
  const updatedOrg = await updateOrganization(org.value)
  if (updatedOrg) {
    currentStage.value += 1
  }
}

const toNextStage = () => {
  const nextStage = currentStage.value + 1
  if (stages[nextStage]) {
    currentStage.value = nextStage
  }
}

const toPreviousStage = () => {
  const previousStage = currentStage.value - 1
  if (stages[previousStage]) {
    currentStage.value = previousStage
  }
}

const publishOrg = async () => {
  if (!org.value) return
  org.value.status = 'published'
  const publishedOrg = await updateOrganization(org.value)
  if (publishedOrg) {
    await router.push({ name: 'Organization', params: { id: String(org.value.id) } })
  }
}
onMounted(async () => {
  const orgId = route.params.id
  org.value = await fetchOrganization(orgId)
})

return { __sfc: true,router, route, stages, currentStage, org, updateOrg, toNextStage, toPreviousStage, publishOrg }
}

})